import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-set-popup',
  templateUrl: './all-set-popup.component.html',
  styleUrls: ['./all-set-popup.component.scss']
})
export class AllSetPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
